import classNames from "classnames";
import {
  FormFieldRadioGroup,
  type FormFieldRadioGroupProps
} from "./FormFieldRadioGroup";

type FormFieldBooleanProps = Omit<
  FormFieldRadioGroupProps,
  "choices" | "type" | "value" | "onChange"
> & {
  allowNull?: boolean;
  type: "boolean";
  value?: boolean | null;
  onChange?: (value: boolean | null) => void;
};

function FormFieldBoolean({
  allowNull,
  type,
  ...formFieldRadioProps
}: FormFieldBooleanProps) {
  return (
    <FormFieldRadioGroup
      {...formFieldRadioProps}
      choices={[
        { value: "true", label: "Ja" },
        { value: "false", label: "Nein" },
        ...(allowNull ? [{ value: "", label: "Unbekannt" }] : [])
      ]}
      className={classNames("FormFieldBoolean", formFieldRadioProps.className)}
      type="radio"
      value={
        formFieldRadioProps.value === true
          ? "true"
          : formFieldRadioProps.value === false
            ? "false"
            : ""
      }
      onChange={(newValue: string) => {
        const booleanValue =
          newValue === "true" ? true : newValue === "false" ? false : null;
        formFieldRadioProps.onChange?.(booleanValue);
      }}
    />
  );
}

export { FormFieldBoolean, FormFieldBooleanProps };
